<template>
  <div class="about">
    <headerBlack-view class="black"></headerBlack-view>
    <div class="introduce_wrap">
      <div class="introduce_content">
        <img src="@/assets/about/title.png" />
        <div class="introduce">
          《“首都带首府”京银“互联网+教育”首都师范大学“双优云桥”项目》是自北京市教委的指引下，
          自治区教育厅指导下，银川市教委协作下，落实《推动“互联网+教育”互联互助支持合作协议》、
          “首都带首府”京银“互联网+教育”战略合作框架协议基础上，为银川市量身定制的“互联网+教育”
          创新研学研修范式
          <br />
          <br />所谓“双优”是指，首都师范大学和银川地区为教育事业所做的努力实现双赢，双方在“互联啊+教育”
          领域走在北京前列、宁夏前列，继而成为全国的样板，即两地都优则为“双优”。所谓的“云桥”是指，
          借助互联网环境下的宁夏教育公共资源平台，即宁夏“教育云”平台，在北京和银川两地架起一座“教育管理、
          教学应用、教师培训、学生互动、教研生成”的“跨时空无障碍的大数据桥”，致力于服务“互联网+教育”师范
          区建设，使“互联网+教育”示范区从建设迈向应用
        </div>
      </div>
    </div>
    <div class="hope_wrap">
      <div class="shadow flex-align-around">
        <div class="hope_content flex-align-between">
          <div class="hope flex-column">
            <div class="hope_top flex-align">
              <img src="@/assets/about/hope.png" />
              <div class="flex-column-between">
                <span class="hope_title">愿景</span>
                <span class="hope_english">Our’s Wishes</span>
              </div>
            </div>
            <div class="hope_bottom flex-column">
              <span>培养一批既懂教育更懂教育技术的教师团队，</span>
              <span>打造一批名优学校，做“有魂”的教育信息化，</span>
              <span>为国家“互联网+教育”示范区建设提供银川样本和经验。</span>
            </div>
          </div>
          <div class="mission flex-column">
            <div class="mission_top flex-align">
              <img src="@/assets/about/bird.png" />
              <div class="flex-column-between">
                <span class="hope_title">使命</span>
                <span class="hope_english">Our’s Duty</span>
              </div>
            </div>
            <div class="mission_bottom flex-column">
              <span>为新时代教育扶贫援助转型升级、提质增效探索出一条新路，</span>
              <span>将结合具体实施情况，持续完善和优化项目方案，</span>
              <span>形成可复制、可推广的“互联网+教育”常态化工作机制，</span>
              <span>力争在全国发挥辐射带动作用，引领智能教育蓬勃发展。</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="project_name">项目历程</div>
    <div class="project_wrap">
      <div class="project_content">
        <!-- <img src="@/assets/about/arrows.png" class="arrows" />   -->
      </div>
    </div>
    <div class="join">加入我们</div>
    <div class="join_wrap">
      <div class="join_top flex-align-between">
        <div class="img-box">
          <img src="@/assets/about/join1.png" />
        </div>
        <img src="@/assets/about/join2.png" />
      </div>
      <div class="join_bottom  flex-align-wrap">
        <div class="job_item flex-column-between" :class="{'job_item2':(index+1)%3==0}"  v-for="(item,index) in jobList" :key=index>
          <div class="item_wrap">
            <div class="job_name">{{item.name}}</div>
            <div class="job_describe">职位描述</div>
            <div class="job_content">
              {{item.description}}
            </div>
          </div>
          <div class="job_btn flex-align-between" style="display:none">
            <div class="download">下载报名表</div>
            <div class="upload">上传报名表</div>
          </div>
          <img src="@/assets/about/job.png" class="job_img" v-if="item.isShow==1">
        </div>
      </div>
    </div>
    <footer-view></footer-view>
  </div>
</template>

<script>
export default {
    data(){
        return{
          jobList:[]
        }
    },
    methods:{
      async GetAbout(){
        let resData = await Api.About.getlist()
        console.log(resData)
        this.jobList = resData.data
      }
    },
    mounted(){
      this.GetAbout()
    }
};
</script>

<style lang="less">
@import "./about.less";
</style>